import { createContext, useContext } from 'react';
import type { FestivalData } from './types.ts';

/**
 * The published festival data as it travels through the tree, and the hook that reads it.
 *
 * Apart from DataProvider/DataGate (in DataContext.tsx) so neither module exports a mix of
 * components and non-components: a file that does loses Fast Refresh for its components, which
 * is what react-refresh/only-export-components flags. The provider imports the context from
 * here; everything that only *reads* the data imports useFestivalData from here too.
 */
export interface DataState {
  data: FestivalData | null;
  error: string | null;
  loading: boolean;
}

export const DataContext = createContext<DataState>({ data: null, error: null, loading: true });

export function useFestivalData(): DataState {
  return useContext(DataContext);
}
